/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  CreateActivityMutationRequest,
  CreateActivityMutationResponse,
} from "../types/CreateActivity.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const createActivityMutationKey = () =>
  [{ url: "/v1/activity/create-activity" }] as const

export type CreateActivityMutationKey = ReturnType<
  typeof createActivityMutationKey
>

/**
 * @summary Create activity
 * {@link /v1/activity/create-activity}
 */
export async function createActivity(
  data: CreateActivityMutationRequest,
  config: Partial<RequestConfig<CreateActivityMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateActivityMutationResponse,
    ResponseErrorConfig<Error>,
    CreateActivityMutationRequest
  >({
    method: "POST",
    url: `/v1/activity/create-activity`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function createActivityMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<CreateActivityMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = createActivityMutationKey()
  return mutationOptions<
    ResponseConfig<CreateActivityMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateActivityMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return createActivity(data, config)
    },
  })
}

/**
 * @summary Create activity
 * {@link /v1/activity/create-activity}
 */
export function useCreateActivity<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<CreateActivityMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: CreateActivityMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<CreateActivityMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? createActivityMutationKey()

  const baseOptions = createActivityMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<CreateActivityMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateActivityMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<CreateActivityMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateActivityMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<CreateActivityMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateActivityMutationRequest },
    TContext
  >
}
